export enum WalletNames {
  GIVE = "give",
  REWARDS = "rewards",
  FLEXI = "flexi"
}

export interface Context {
  apps: {[key: string]: string}
}
